const Team = () => import('./Team')

export default function installComponents(Vue) {
  Vue.component('Team', Team)
}
